// extracted by mini-css-extract-plugin
module.exports = {"search":"_searchbar_search__SDh1T"};